import { render } from "./expendText.vue?vue&type=template&id=f7055538"
import script from "./expendText.vue?vue&type=script&lang=js"
export * from "./expendText.vue?vue&type=script&lang=js"

import exportComponent from "E:\\edu-ui\\LyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__